import _ from 'lodash';
import axios from 'axios';
import config from '../config.js';
import storage from './storage.js';

const createInstance = ()=>{
    const instance = axios.create({
        withCredentials: true,
        baseURL: config.API_BASE,
    });
    instance.interceptors.request.use(req=>{
        let token = storage.get('sc_token');
        if (token)
            req.headers.Authorization = `Bearer ${token}`;
        return req;
    });
    instance.interceptors.response.use(res=>{
        if (res.headers.getContentType().startsWith('application/json'))
            return res.data;
        return res;
    }, async e=>{
        if (e.response.status==403&&e.response.data.code=='token_expired') {
            let userId = storage.get('sc_user');
            let refreshToken = storage.get('sc_refresh_token');
            let {token} = await api.refreshToken({userId, refreshToken});
            storage.set('sc_token', token);
            e.config.headers.Authorization = `Bearer ${token}`;
            return instance.request(e.config);
        }
        if (e.response.headers.getContentType().startsWith('application/json'))
            return Promise.reject(Object.assign(new Error(e.response.data.message), e.response.data));
        return Promise.reject(e);
    });
    return instance;
};

const api = {
    login: data=>createInstance().post('login', data),
    signup: data=>createInstance().post('signup', data),
    refreshToken: data=>createInstance().post('refresh_token', data),
    verifyEmail: data=>createInstance().post('verify_email', data),
    passwordResetRequest: email=>createInstance().post('reset_password_request', {email}),
    passwordResetConfirm: data=>createInstance().post('reset_password_confirm', data),
    getUser: ()=>createInstance().get('user'),
    contact: data=>createInstance().post('contact', data),
    randomCard: ()=>createInstance().get('random_card'),
    tarotmail: {
        validateStudent: id=>createInstance().get(`/tarotmail/validate_student/${id}`),
        checkEligibility: (id, name, email)=>createInstance().get('/tarotmail/check_eligibility', {params: {id, name, email}}),
        subscribe: (id, data)=>createInstance().post(`/tarotmail/${id}/subscribe`, data),
        unsubscribe: (customerId, email)=>createInstance().post(`tarotmail/${customerId}/unsubscribe`, {email}),
        student: {
            get: ()=>createInstance().get('/tarotmail/student/get'),
            customers: ()=>createInstance().get('/tarotmail/student/customers'),
            downloadEmails: ()=>createInstance().get('/tarotmail/student/download_emails', {responseType: 'blob'}),
            addCustomerRound: customerId=>createInstance().post(`/tarotmail/student/add_customer_round/${customerId}`),
            updateSettings: data=>createInstance().put('/tarotmail/student/settings', data),
            sendTestMail: ()=>createInstance().post('/tarotmail/student/test_mail'),
        },
    },
    admin: {
        users: ()=>createInstance().get('/admin/users'),
        updateUserPermissions: (id, permissions)=>createInstance().put(`/admin/users/${id}/permissions`, {permissions}),
        refreshToken: id=>createInstance().post(`/admin/users/${id}/refresh_token`),
        jobs: opt=>createInstance().get('/admin/metrics/jobs', {params: opt}),
        errors: opt=>createInstance().get('/admin/metrics/errors', {params: opt}),
        jobTypes: ()=>createInstance().get('/admin/job_types'),
    },
};

export default api;
